{
  "A": {
    "x": 0,
    "y": 0
  },
  "B": {
    "x": 1,
    "y": 0
  },
  "C": {
    "x": 2,
    "y": 0
  },
  "D": {
    "x": 3,
    "y": 0
  },
  "E": {
    "x": 4,
    "y": 0
  },
  "F": {
    "x": 5,
    "y": 0
  },
  "G": {
    "x": 6,
    "y": 0
  },
  "H": {
    "x": 7,
    "y": 0
  },
  "I": {
    "x": 8,
    "y": 0
  },
  "J": {
    "x": 9,
    "y": 0
  },
  "K": {
    "x": 10,
    "y": 0
  },
  "L": {
    "x": 11,
    "y": 0
  },
  "M": {
    "x": 12,
    "y": 0
  },
  "N": {
    "x": 13,
    "y": 0
  },
  "O": {
    "x": 14,
    "y": 0
  },
  "P": {
    "x": 15,
    "y": 0
  },
  "Q": {
    "x": 16,
    "y": 0
  },
  "R": {
    "x": 17,
    "y": 0
  },
  "S": {
    "x": 18,
    "y": 0
  },
  "T": {
    "x": 19,
    "y": 0
  },
  "U": {
    "x": 20,
    "y": 0
  },
  "V": {
    "x": 21,
    "y": 0
  },
  "W": {
    "x": 22,
    "y": 0
  },
  "X": {
    "x": 23,
    "y": 0
  },
  "Y": {
    "x": 24,
    "y": 0
  },
  "Z": {
    "x": 25,
    "y": 0
  },
  "0": {
    "x": 0,
    "y": 1
  },
  "1": {
    "x": 1,
    "y": 1
  },
  "2": {
    "x": 2,
    "y": 1
  },
  "3": {
    "x": 3,
    "y": 1
  },
  "4": {
    "x": 4,
    "y": 1
  },
  "5": {
    "x": 5,
    "y": 1
  },
  "6": {
    "x": 6,
    "y": 1
  },
  "7": {
    "x": 7,
    "y": 1
  },
  "8": {
    "x": 8,
    "y": 1
  },
  "9": {
    "x": 9,
    "y": 1
  },
  "!": {
    "x": 10,
    "y": 1
  },
  "?": {
    "x": 11,
    "y": 1
  },
  ".": {
    "x": 12,
    "y": 1
  },
  ",": {
    "x": 13,
    "y": 1
  },
  "/": {
    "x": 14,
    "y": 1
  },
  "\"": {
    "x": 15,
    "y": 1
  }
}
